import React from 'react';

import { Controller } from 'react-hook-form';
import { Tab, Tabs } from '@material-ui/core';

const ControlledTabs = ({
  name,
  control,
  onChange: onChangeHandler,
  tabs = [],
  ...rest
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <Tabs
          value={value}
          onChange={(event, selectedValue) => {
            if (onChangeHandler) {
              onChangeHandler(selectedValue, event);
            }
            onChange(selectedValue);
            return selectedValue;
          }}
          {...rest}
        >
          {tabs.length > 0 &&
            tabs.map((tabProps, index) => <Tab key={index} {...tabProps} />)}
        </Tabs>
      )}
    />
  );
};

export default ControlledTabs;
